// @flow

import { h }             from "preact";
import { PureComponent } from "shared-components";
import { connect }       from "preact-redux";
import { logout }        from "store-reducers/customer.js";

import Redirect from "../../components/Redirect";

@connect(
  state => ({
    loggedIn : state.customer.loggedIn,
  }),
  dispatch => ({
    logout: () => dispatch(logout()),
  })
)
export default class Logout extends PureComponent {
  componentWillMount() {
    if (this.props.loggedIn) {
      this.props.logout();
    }
  }

  render({ loggedIn }: Props, state: any, { t }: Context) {
    if (!loggedIn) {
      return <Redirect to="/login" />
    }
  }
}
